import gsap from 'gsap'

import { MOBILE_ACTIVE_CLASS } from '../constants/header'

class NavigationMobileAnimations {
  constructor(
    mainEl,
    { menuContainer, menuScrollContainer, subMenuScrollContainer, menuItems, metaMenuItems }
  ) {
    this.el = mainEl
    this.menuContainer = menuContainer

    this.menuScrollContainer = menuScrollContainer
    this.subMenuScrollContainer = subMenuScrollContainer
    this.menuItems = menuItems
    this.metaMenuItems = metaMenuItems
  }

  createSubMenuItemAnimation(activeMenuEl) {
    const tl = gsap.timeline()
    tl.from(activeMenuEl.find('a'), {
      duration: 0.175,
      opacity: 0,
      ease: 'sine.inOut',
      stagger: 0.1,
    })

    return tl
  }

  createMenuItemAnimation() {
    const tl = gsap.timeline()
    // main items
    tl.from(this.menuItems, {
      duration: 0.175,
      opacity: 0,
      ease: 'sine.inOut',
      stagger: 0.1,
    })
    // meta menu items
    tl.from(this.metaMenuItems, {
      duration: 0.15,
      opacity: 0,
      ease: 'sine.inOut',
    })

    return tl
  }

  createOpenAnimation(logoContainer) {
    const tl = gsap.timeline({
      onStart: () => {
        this.el.addClass(MOBILE_ACTIVE_CLASS)
        this.menuContainer.css('display', 'block')
      },
    })
    // Stop the timeline
    tl.pause()
    // animate menu container
    tl.from(this.menuContainer, {
      duration: 0.175,
      yPercent: -5,
      opacity: 0,
      ease: 'sine.inOut',
    })
    // Animate the menu items
    tl.add(this.createMenuItemAnimation())
    // animate the logo container
    tl.from(logoContainer, {
      duration: 0.2,
      opacity: 0,
      yPercent: 60,
      ease: 'sine.inOut',
    })

    return tl
  }

  createCloseAnimation({ onCompleteCallback }) {
    const tl = gsap.timeline({
      onStart: () => {
        this.el.removeClass(MOBILE_ACTIVE_CLASS)
      },
      onComplete: () => {
        this.menuContainer.css('display', '')
        onCompleteCallback()
      },
    })

    // Stop the timeline
    tl.pause()
    // animate the flyout container
    tl.to(this.menuContainer, {
      duration: 0.175,
      yPercent: -5,
      opacity: 0,
      ease: 'sine.inOut',
    })

    return tl
  }

  createSubMenuOpenAnimation(activeMenuEl) {
    const tl = gsap.timeline()

    tl.pause()

    tl.fromTo(
      this.menuScrollContainer,
      {
        xPercent: 0,
        opacity: 1,
      },
      {
        duration: 0.175,
        xPercent: -100,
        opacity: 0,
      }
    )

    tl.fromTo(
      this.subMenuScrollContainer,
      {
        xPercent: 0,
      },
      {
        duration: 0.175,
        xPercent: -100,
      },
      '<'
    )
    // show the menu Items
    tl.add(this.createSubMenuItemAnimation(activeMenuEl), '<')

    return tl
  }

  createSubMenuCloseAnimation({ onCompleteCallback }) {
    const tl = gsap.timeline({
      onComplete: () => {
        onCompleteCallback()
      },
    })

    tl.pause()

    tl.to(this.menuScrollContainer, {
      duration: 0.175,
      xPercent: 0,
      opacity: 1,
    })

    tl.to(
      this.subMenuScrollContainer,
      {
        duration: 0.175,
        xPercent: 0,
      },
      '<'
    )

    tl.add(this.createMenuItemAnimation(), '<')

    return tl
  }
}

export default NavigationMobileAnimations
